module.exports = __webpack_public_path__ + "files/c2224ad86b674da7eedf2eeeaf3786ea.png";